import { Pipe, PipeTransform } from '@angular/core';
import { LightSceneDetail, LightSceneRef } from '../services/interfaces/light.interface';
import { Room } from './../../../common/interfaces/item.interface';

@Pipe({
  name: 'scenesInRoom'
})
export class ScenesInRoomPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!!value && Array.isArray(value) && !!args && args !== '0') {
      let scenes = <LightSceneRef[]>value;
      let roomId = parseInt(args);

      return scenes.filter(s => {
        return s.roomId === roomId
      });;
    }

    return value;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/pipes/scenes-in-room.pipe.ts